<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.cityName"
              placeholder="请输入城市名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入品规名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="状态"
              clearable
              style="width: 100%;"
              @keyup.enter.native="searchData()"
            >
              <el-option
                label="启用"
                value="1"
              />
              <el-option
                label="停用"
                value="2"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @stop="handleDisable(arguments)"
        @start="handleEnable(arguments)"
        @settingByCity="handleSettingByCity"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
        @updateProduct="updateProductFun(arguments)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 按市场批量设置 -->
    <setting-by-city-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogSettingByCityVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 按市场批量设置
import settingByCityDialog from './components/settingByCityDialog'
// 数据请求API
import { loadSurveyProductSettingListDataApi, exportSurveyProductSettingListDataApi, updateSurveyProductSettingStatusApi } from '@/api/v2/surveyProductSetting'

export default {
  name: 'SurveyProductSetting',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog,
    settingByCityDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'survey_product_setting_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['survey_product_setting_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['survey_product_setting_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['survey_product_setting_start'],
            prop: 'start',
            label: '启用',
            method: 'start'
          },
          {
            permissionSigns: ['survey_product_setting_stop'],
            prop: 'stop',
            label: '停用',
            method: 'stop'
          },
          {
            permissionSigns: ['survey_product_setting_add', 'survey_product_setting_edit'],
            prop: 'settingByCity',
            label: '按市场设置品规',
            method: 'settingByCity'
          },
          // {
          //   permissionSigns: ['survey_product_setting_update_collect_store_product'],
          //   prop: 'updateProduct',
          //   label: '更新采集零售户档案采集设置',
          //   method: 'updateProduct'
          // },
          {
            permissionSigns: ['survey_product_setting_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['survey_product_setting_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
          cityName: '',
          status: '',
        },
      },
      id: null, // 选中的单据ID      
      eventType: '',
      dialogTitle: '',
      dialogAddEditViewVisible: false,
      dialogSettingByCityVisible: false,
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 130 },
      { prop: 'industrialEnterprisesName', label: '所属工业', filterColumn: 'industrial_enterprises_name', width: 120 },
      { prop: 'brandName', label: '品牌', filterColumn: 'brand_name', width: 100 },
      { prop: 'name', label: '名称', width: 150 },
      { prop: 'minPackage', label: '最小包库存', filterColumn: 'min_package', width: 120 },
      { prop: 'maxPackage', label: '最大包库存', filterColumn: 'max_package', width: 120 },
      { prop: 'minPackagePrice', label: '最小包价格', filterColumn: 'min_package_price', width: 120 },
      { prop: 'maxPackagePrice', label: '最大包价格', filterColumn: 'max_package_price', width: 120 },
      { prop: 'minStripPrice', label: '最小条价格', filterColumn: 'min_strip_price', width: 120 },
      { prop: 'maxStripPrice', label: '最大条价格', filterColumn: 'max_strip_price', width: 120 },
      { prop: 'minPrice', label: '最小交易价', filterColumn: 'min_price', width: 120 },
      { prop: 'maxPrice', label: '最大交易价', filterColumn: 'max_price', width: 120 },
      { prop: 'surveyCount', label: '采集份数', filterColumn: 'survey_count', width: 120 },
      { prop: 'serial', label: '采集排序', filterColumn: 'serial', width: 120 },
      { prop: 'isCompetitorValue', label: '是否竞品', filterColumn: 'is_competitor', filterValue: 'isCompetitor', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }], width: 120 },
      { prop: 'weekReportViewValue', label: '周报是否统计', filterColumn: 'week_report_view', filterValue: 'weekReportView', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 130 },
      { prop: 'monthReportViewValue', label: '月报是否统计', filterColumn: 'month_report_view', filterValue: 'monthReportView', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 130 },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '启用', value: 1 }, { label: '停用', value: 2 }], width: 90 },
      { prop: 'remark', label: '备注', width: 150 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadSurveyProductSettingListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || []);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    //新增
    handleAdd() {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogTitle = '新增单品调查品规信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 修改
    handleEdit(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogTitle = '修改单品调查品规信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 按市场设置调研品规 
    handleSettingByCity() {
      let _this = this;
      _this.eventType = 'settingByCity'
      _this.dialogTitle = '按市场设置调研品规'
      _this.dialogSettingByCityVisible = !_this.dialogSettingByCityVisible
    },
    // 查看
    handleView(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogTitle = '查看单品调查品规信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 停用
    handleDisable(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要停用的单品调查品规', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        _this.$message({ message: '单品调查品规不在启用状态，不能停用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定停用该单品调查品规信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateSurveyProductSettingStatusApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '停用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 启用
    handleEnable(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要启用的单品调查品规', type: 'warning' })
        return
      } else if (args[0].status === 1) {
        _this.$message({ message: '单品调查品规不在停用状态，不能启用', type: 'warning' })
        return
      }
      _this.$confirm('是否确定启用该单品调查品规信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateSurveyProductSettingStatusApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '启用成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 更新采集品规
    updateProductFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要更新的单品调查品规', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        _this.$message({ message: '单品调查品规不在启用状态，不能更新', type: 'warning' })
        return
      }
      _this.$confirm('是否确定更新采集零售户档案采集设置？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        // this.masterList.tableLoading = true
        // updateCollectStoreInfoSingleProductApi({ id: args[0].id }).then(res => {
        //   if (res.mark === '200') {
        //     this.$message({
        //       message: res.message,
        //       type: 'success'
        //     })
        //   }
        //   this.masterList.tableLoading = false
        // })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportSurveyProductSettingListDataApi(_this.exportObj).then(response => {
        const { data } = response;
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
